export default __webpack_public_path__ + "static/media/CreditCardCleanpro.0acdccc9.png";